const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/user/app/$appId/features-barcode/list-create.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { BarcodeCreateConfigFilterParamSchema } from '@apps/main/features/user/pages/app/detail/feature-barcode/list-create-schema';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_main/user/app/$appId/features-barcode/list-create')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: BarcodeCreateConfigFilterParamSchema
});